// apps/prompts/src/components/KeyboardShortcutsHelp.tsx
import { Modal } from '@neuroforge/ui'

import { getRegisteredShortcuts } from '../hooks/useKeyboardShortcuts'

interface KeyboardShortcutsHelpProps {
  isOpen: boolean
  onClose: () => void
}

const GLOBAL_SHORTCUTS = [
  {
    keys: navigator.platform.includes('Mac') ? '⌘+K' : 'Ctrl+K',
    description: 'Ouvrir la recherche',
  },
  { keys: 'Escape', description: 'Fermer modale / panel' },
  { keys: '?', description: 'Afficher les raccourcis' },
  { keys: '↑↓', description: 'Naviguer dans les résultats' },
  { keys: 'Enter', description: 'Ouvrir le prompt sélectionné' },
]

export default function KeyboardShortcutsHelp({ isOpen, onClose }: KeyboardShortcutsHelpProps) {
  const dynamicShortcuts = getRegisteredShortcuts()
  const allShortcuts = [...GLOBAL_SHORTCUTS, ...dynamicShortcuts]

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Raccourcis clavier">
      <div className="space-y-1">
        {allShortcuts.map((shortcut) => (
          <div
            key={shortcut.keys}
            className="flex items-center justify-between rounded-xl px-3 py-2.5 transition-colors hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
          >
            <span className="text-sm text-slate-600 dark:text-slate-300">
              {shortcut.description}
            </span>
            <kbd className="flex items-center gap-1">
              {shortcut.keys.split('+').map((key, i) => (
                <span
                  key={i}
                  className="inline-flex h-7 min-w-[28px] items-center justify-center rounded-lg border border-slate-300/40 bg-slate-200/60 px-2 text-[11px] font-bold text-slate-600 dark:border-slate-600/40 dark:bg-slate-700/60 dark:text-slate-300"
                >
                  {key}
                </span>
              ))}
            </kbd>
          </div>
        ))}
      </div>
      <p className="mt-4 text-center text-[10px] text-slate-400">
        Appuie sur{' '}
        <kbd className="rounded bg-slate-200/60 px-1.5 py-0.5 text-[10px] font-bold dark:bg-slate-700/60">
          ?
        </kbd>{' '}
        pour afficher ce panneau
      </p>
    </Modal>
  )
}
